// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomButtonBox_wrapper__4fav2","left":"BottomButtonBox_left__gUYqA","right":"BottomButtonBox_right__85kuy"};